import React from 'react'
import { Navigate } from 'react-router-dom'

const PrivateRouter = ({ children, redirectTo }) => {
    const token = window.localStorage.getItem('authorization');
    return token ? children : <Navigate to={redirectTo} />;
}

export default PrivateRouter